import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BasePaysheet } from '../models/base-paysheet';

@Injectable({
  providedIn: 'root'
})
export class BasePaysheetService {

  constructor(private http:HttpClient) { }

  getBasePaysheets(date1:Date, date2:Date) : Promise<BasePaysheet[]> {
    return this.http.get<BasePaysheet[]>('/api/paysheet/base', {
      params: {
        date1: date1.toString(), 
        date2: date2.toString()
      }
    }).toPromise();
  }

  postBasePaysheet(paysheet:BasePaysheet) : Promise<BasePaysheet> {
    return this.http.post<BasePaysheet>('/api/paysheet/base', paysheet)
      .toPromise();
  }

  getBasePaysheet(id:Number) : Promise<BasePaysheet> {
    return this.http.get<BasePaysheet>('/api/paysheet/base/' + id)
      .toPromise();
  }
  
  putBasePaysheet(paysheet:BasePaysheet) : Promise<BasePaysheet> {
    return this.http.post<BasePaysheet>('/api/paysheet/base/' + paysheet.id + '/edit', paysheet)
      .toPromise();
  }
  
  deleteBasePaysheet(paysheet:BasePaysheet) : Promise<void> {
    return this.http.get<void>('/api/paysheet/base/' + paysheet.id + '/delete')
      .toPromise();
  }
}
